import React from 'react';

export default function Button({ 
  as: Component = 'button', 
  children, 
  className = '', 
  variant = 'primary',
  size = 'medium',
  ...props 
}) {
  // Define button variants using new color system.
  // Primary: in dark mode use primary-dark as base so it's not overly bright; light mode stays full primary.
  const variants = {
    // Primary CTA — confident cornflower blue with brand-tinted shadow for depth
    primary:
      'bg-primary hover:bg-primary-dark text-text-inverse shadow-brand-sm hover:shadow-brand-md border border-primary/80 dark:bg-primary-dark dark:hover:bg-primary dark:border-primary',
    secondary: 'bg-secondary hover:bg-primary text-text-inverse shadow-brand-sm hover:shadow-brand-md border border-secondary/80',
    success: 'bg-success hover:bg-success-dark text-white shadow-sm hover:shadow-md border border-success-dark dark:bg-success-dark dark:hover:bg-success dark:border-success/70',
    warning: 'bg-warning hover:bg-warning-dark text-white shadow-sm hover:shadow-md border border-warning-dark dark:bg-amber-700 dark:hover:bg-amber-600 dark:border-amber-600',
    danger: 'bg-danger hover:bg-danger-dark text-white shadow-sm hover:shadow-md border border-danger-dark',
    // Default: subtle surface with visible border — good for secondary actions
    default: 'bg-surface hover:bg-surface-subtle text-text-primary shadow-brand-sm hover:shadow-brand-md border border-border-medium',
    outline: 'bg-transparent border border-border-medium text-text-primary hover:bg-surface-subtle hover:border-primary/50',
    // Ghost: for tab/nav buttons — no border, highlights on hover with brand tint
    ghost: 'bg-transparent text-text-secondary hover:bg-primary-light hover:text-primary border-0',
    nav: 'bg-transparent text-text-inverse hover:text-text-inverse hover:bg-white/10 border-0 shadow-none',
    link: 'bg-transparent text-primary hover:text-primary-dark underline-offset-4 hover:underline'
  };

  // Define button sizes - ensure 44px minimum touch target on mobile
  const sizes = {
    small: 'px-3 py-2 sm:py-1.5 text-sm font-medium rounded-md min-h-[44px] sm:min-h-0',
    medium: 'px-4 py-2.5 sm:py-2 text-sm font-medium rounded-lg min-h-[44px] sm:min-h-0',
    large: 'px-6 py-3 text-base font-semibold rounded-lg min-h-[48px]'
  };

  // Base styles
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <Component
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
} 